/* Paula Nails — theme.js */
(function () {
  'use strict';

  var T = window.theme || {};
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------- Formato de precios ---------- */
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var format = T.moneyFormat || '€{{amount_with_comma_separator}}';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = (Number(cents) / 100);
    function fmt(num, decimals, thousands, decimal) {
      var parts = num.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    var out;
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': out = fmt(value, 0, ',', '.'); break;
      case 'amount_with_comma_separator': out = fmt(value, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = fmt(value, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': out = fmt(value, 2, "'", '.'); break;
      default: out = fmt(value, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, out);
  }
  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Barra de anuncios ---------- */
  $$('[data-announce]').forEach(function (bar) {
    var msgs = $$('.announce__msg', bar);
    if (msgs.length < 2) return;
    var i = 0;
    var speed = (parseInt(bar.dataset.speed, 10) || 5) * 1000;
    setInterval(function () {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, speed);
  });

  /* ---------- Cabecera ---------- */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 10); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  var searchToggle = $('[data-search-toggle]');
  var searchPanel = $('[data-search-panel]');
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function () {
      var open = searchPanel.hasAttribute('hidden');
      searchPanel.toggleAttribute('hidden', !open);
      searchToggle.setAttribute('aria-expanded', open);
      if (open) { var input = $('input[type=search]', searchPanel); if (input) input.focus(); }
    });
  }

  /* ---------- Paneles (menú móvil y carrito) ---------- */
  var lastFocus = null;
  function openPanel(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    var focusable = $('.drawer__panel, .mobile-menu__panel', el);
    if (focusable) setTimeout(function () { focusable.focus({ preventScroll: true }); }, 50);
  }
  function closePanel(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  }

  var mobileMenu = $('#MobileMenu');
  var burger = $('[data-menu-open]');
  if (mobileMenu && burger) {
    $('.mobile-menu__panel', mobileMenu).setAttribute('tabindex', '-1');
    burger.addEventListener('click', function () { openPanel(mobileMenu); burger.setAttribute('aria-expanded', 'true'); });
    $$('[data-menu-close]', mobileMenu).forEach(function (b) {
      b.addEventListener('click', function () { closePanel(mobileMenu); burger.setAttribute('aria-expanded', 'false'); });
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('.drawer.is-open, .mobile-menu.is-open').forEach(closePanel);
  });

  /* ---------- Portada (slider) ---------- */
  $$('[data-slider]').forEach(function (slider) {
    var track = $('[data-slider-track]', slider);
    var slides = $$('[data-slide]', slider);
    var dots = $$('[data-dot]', slider);
    if (!track || slides.length < 2) return;
    var current = 0;
    var go = function (i) {
      current = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[current].offsetLeft, behavior: 'smooth' });
    };
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.dot, 10)); restart(); }); });
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      if (i !== current) current = i;
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
    }, { passive: true });
    var seconds = parseInt(slider.dataset.autoplay, 10) || 0;
    var timer = null;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function restart() {
      if (timer) clearInterval(timer);
      if (seconds > 0 && !reduce) timer = setInterval(function () { go(current + 1); }, seconds * 1000);
    }
    slider.addEventListener('mouseenter', function () { if (timer) clearInterval(timer); });
    slider.addEventListener('mouseleave', restart);
    restart();
  });

  /* ---------- Carruseles de productos ---------- */
  function initCarousels(ctx) {
    $$('.section', ctx).forEach(function (section) {
      var track = $('[data-carousel]', section);
      if (!track || track.dataset.ready) return;
      track.dataset.ready = '1';
      var step = function () {
        var item = track.firstElementChild;
        return item ? item.getBoundingClientRect().width + 22 : track.clientWidth;
      };
      var prev = $('[data-carousel-prev]', section);
      var next = $('[data-carousel-next]', section);
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  }
  initCarousels(document);

  /* ---------- Cantidad (+ / -) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.product .qty__btn');
    if (!btn) return;
    var input = $('input', btn.parentNode);
    var val = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.qty, 10));
    input.value = val;
  });

  /* ---------- Producto: variantes y galería ---------- */
  $$('[data-product]').forEach(function (root) {
    var json = $('[data-variants]', root);
    if (!json) return;
    var variants = JSON.parse(json.textContent);
    var select = $('[data-variant-select]', root);
    var addBtn = $('[data-add-btn]', root);
    var priceEl = $('[data-price]', root);
    var track = $('[data-gallery-track]', root);
    var thumbs = $$('[data-thumb]', root);

    function showMedia(id) {
      if (!track || !id) return;
      var slide = $('[data-media-id="' + id + '"]', track);
      if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.thumb == id); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t.dataset.thumb); }); });
    if (track) {
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      }, { passive: true });
    }

    function selectedOptions() {
      return $$('.option', root).map(function (fs) {
        var checked = $('input:checked', fs);
        var sel = $('select', fs);
        return checked ? checked.value : (sel ? sel.value : null);
      });
    }

    function markAvailability(opts) {
      $$('.option', root).forEach(function (fs, idx) {
        $$('input[data-option-radio]', fs).forEach(function (input) {
          var test = opts.slice(); test[idx] = input.value;
          var ok = variants.some(function (v) {
            return v.available && v.options.every(function (o, i) { return i === idx ? o === input.value : (i > idx ? true : o === test[i]); });
          });
          input.classList.toggle('is-unavailable', !ok);
        });
      });
    }

    function update() {
      var opts = selectedOptions();
      $$('.option', root).forEach(function (fs, i) {
        var label = $('[data-option-value]', fs);
        if (label) label.textContent = opts[i];
      });
      var variant = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      markAvailability(opts);
      if (!variant) {
        addBtn.disabled = true;
        addBtn.textContent = 'No disponible';
        return;
      }
      select.value = variant.id;
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? 'Añadir al carrito' : 'Agotado';
      if (priceEl) {
        var cur = $('[data-price-current]', priceEl);
        var cmp = $('[data-price-compare]', priceEl);
        var sale = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (cur) cur.textContent = formatMoney(variant.price);
        if (cmp) { cmp.textContent = sale ? formatMoney(variant.compare_at_price) : ''; cmp.hidden = !sale; }
        priceEl.classList.toggle('price--sale', !!sale);
      }
      if (variant.featured_media) showMedia(variant.featured_media.id);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    $$('[data-option-radio], [data-option-select]', root).forEach(function (el) {
      el.addEventListener('change', update);
    });
    if ($$('.option', root).length) markAvailability(selectedOptions());
  });

  /* ---------- Productos relacionados ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    fetch(el.dataset.recommendations)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = $('[data-recommendations]', tmp);
        if (fresh && fresh.innerHTML.trim()) {
          el.innerHTML = fresh.innerHTML;
          initCarousels(el.parentNode);
        }
      })
      .catch(function () {});
  });

  /* ---------- Colección: autoenvío de filtros y orden ---------- */
  $$('[data-filter-form]').forEach(function (form) {
    var submit = function () {
      var params = new URLSearchParams(new FormData(form));
      Array.from(params.keys()).forEach(function (k) {
        if (params.get(k) === '') params.delete(k);
      });
      window.location.search = params.toString();
    };
    $$('input[type=checkbox], select', form).forEach(function (el) { el.addEventListener('change', submit); });
    form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });
  });
  document.addEventListener('click', function (e) {
    $$('[data-filters][open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });
  $$('#CartForm [data-auto-submit]').forEach(function (input) {
    input.addEventListener('change', function () { input.form.submit(); });
  });

  /* ---------- Carrito lateral (AJAX) ---------- */
  var drawer = $('#CartDrawer');
  var useDrawer = T.cartType === 'drawer' && drawer;

  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function shippingBar(total) {
    var t = T.freeShipping || 0;
    if (!t) return '';
    var remaining = t - total;
    var pct = Math.min(100, Math.round(total * 100 / t));
    var text = remaining > 0
      ? 'Te faltan <strong>' + formatMoney(remaining) + '</strong> para el envío gratis'
      : 'Tienes el <strong>envío gratis</strong>';
    return '<div class="ship-bar"><p class="ship-bar__text">' + text + '</p><div class="ship-bar__track"><span style="width:' + pct + '%"></span></div></div>';
  }

  function renderDrawer(cart) {
    if (!drawer) return;
    updateCount(cart.item_count);
    $('[data-cart-shipping]', drawer).innerHTML = cart.item_count ? shippingBar(cart.total_price) : '';
    var body = $('[data-cart-items]', drawer);
    var foot = $('[data-cart-foot]', drawer);
    if (!cart.item_count) {
      body.innerHTML = '<div class="drawer__empty"><p>Tu carrito está vacío.</p><a class="btn btn--outline" href="' + (T.routes.root || '/') + 'collections/all">Ver productos</a></div>';
      foot.hidden = true;
      return;
    }
    body.innerHTML = cart.items.map(function (item, i) {
      var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2') : '';
      var imgTag = img ? '<img src="' + esc(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=200" alt="" loading="lazy" width="80" height="80">' : '';
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<p class="dline__variant">' + esc(item.variant_title) + '</p>' : '';
      return '<div class="dline">' +
        '<a class="dline__media" href="' + esc(item.url) + '">' + imgTag + '</a>' +
        '<div>' +
          '<a class="dline__title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' + variant +
          '<div class="dline__row">' +
            '<div class="qty">' +
              '<button type="button" class="qty__btn" data-line="' + (i + 1) + '" data-q="' + (item.quantity - 1) + '" aria-label="Quitar uno"><svg class="icon" viewBox="0 0 24 24"><path d="M6 12h12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg></button>' +
              '<input type="number" value="' + item.quantity + '" min="0" data-line-input="' + (i + 1) + '" aria-label="Cantidad">' +
              '<button type="button" class="qty__btn" data-line="' + (i + 1) + '" data-q="' + (item.quantity + 1) + '" aria-label="Añadir uno"><svg class="icon" viewBox="0 0 24 24"><path d="M6 12h12M12 6v12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg></button>' +
            '</div>' +
            '<strong>' + formatMoney(item.final_line_price) + '</strong>' +
          '</div>' +
          '<button type="button" class="dline__remove" data-line="' + (i + 1) + '" data-q="0">Eliminar</button>' +
        '</div>' +
      '</div>';
    }).join('');
    $('[data-cart-subtotal]', drawer).textContent = formatMoney(cart.total_price);
    foot.hidden = false;
  }

  function fetchCart() {
    return fetch(T.routes.root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function changeLine(line, qty) {
    drawer.classList.add('is-loading');
    return fetch(T.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: Math.max(0, qty) })
    })
      .then(function (r) { return r.json(); })
      .then(renderDrawer)
      .finally(function () { drawer.classList.remove('is-loading'); });
  }

  if (useDrawer) {
    $('.drawer__panel', drawer).setAttribute('tabindex', '-1');
    $$('[data-drawer-close]', drawer).forEach(function (b) { b.addEventListener('click', function () { closePanel(drawer); }); });
    $$('[data-cart-open]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        fetchCart().then(renderDrawer);
        openPanel(drawer);
      });
    });
    drawer.addEventListener('click', function (e) {
      var b = e.target.closest('[data-line]');
      if (b) changeLine(parseInt(b.dataset.line, 10), parseInt(b.dataset.q, 10));
    });
    drawer.addEventListener('change', function (e) {
      var input = e.target.closest('[data-line-input]');
      if (input) changeLine(parseInt(input.dataset.lineInput, 10), parseInt(input.value, 10) || 0);
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form || !useDrawer) return;
    e.preventDefault();
    var btn = $('[type=submit]', form);
    var errorEl = $('[data-cart-error]', form);
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Añadiendo…'; }
    if (errorEl) errorEl.hidden = true;
    fetch(T.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || 'No se ha podido añadir el producto.');
        return fetchCart().then(function (cart) { renderDrawer(cart); openPanel(drawer); });
      })
      .catch(function (err) {
        if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
        else window.alert(err.message);
      })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
  });
})();
